var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
export default function waitForWeglot(retry = 0) {
  return __async(this, null, function* () {
    if (window.Weglot && window.VocaWeglotConfig) {
      return;
    }
    if (retry > 10) {
      throw new Error("Voca Weglot: failed to load vendors");
    }
    yield new Promise((resolve) => setTimeout(resolve, 1e3));
    return waitForWeglot(retry + 1);
  });
}
